import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import styled from 'styled-components';
import UiKit from '../../../../../shared/ui/ui-kit';
import { colorsPalette } from '../../../../../shared/ui/styles/colors-palette';
import {
  LoadingStatus,
  SubmittingStatus,
} from '../../../../../shared/infrastructure/types/common/common-types';
import { YandexCloudNotice } from '../YandexCloudNotice';

let LoginForm = function (): React.ReactElement {
  const { t } = useTranslation();
  const { authorizationUiModule, routingModule } = useUILogic();
  const loginUIManager = authorizationUiModule.loginUIManager;
  const yandexCloudManager = authorizationUiModule.module.yandexCloudManager;

  return (
    <LoginWrapper>
      <YandexCloudNotice page="login" />
      {loginUIManager.coreManager.pageErrorKey && (
        <FormError>
          <Trans i18nKey={loginUIManager.coreManager.pageErrorKey} />
        </FormError>
      )}
      <FieldsGroup>
        <UiKit.form.Item.VerticalLayoutTemplate label={t('login.loginLabel')}>
          <UiKit.form.Validation
            validateStatus={loginUIManager.coreManager.validator.login.isValid ? '' : 'error'}
            message={t(loginUIManager.coreManager.validator.login.errors[0]) as string}
            turnValidation={
              loginUIManager.coreManager.loginFormStatus === SubmittingStatus.ERROR_SUBMITTING
            }
          >
            <UiKit.Input
              value={loginUIManager.coreManager.login}
              onChange={value => loginUIManager.coreManager.setLogin(value)}
            />
          </UiKit.form.Validation>
        </UiKit.form.Item.VerticalLayoutTemplate>
        <UiKit.form.Item.VerticalLayoutTemplate label={t('login.passwordLabel')}>
          <UiKit.form.Validation
            validateStatus={loginUIManager.coreManager.validator.password.isValid ? '' : 'error'}
            message={t(loginUIManager.coreManager.validator.password.errors[0]) as string}
            turnValidation={
              loginUIManager.coreManager.loginFormStatus === SubmittingStatus.ERROR_SUBMITTING
            }
          >
            <UiKit.Input
              value={loginUIManager.coreManager.password}
              onChange={value => loginUIManager.coreManager.setPassword(value)}
              type={'password'}
              showPasswordVisibilityToggle={true}
            />
          </UiKit.form.Validation>
        </UiKit.form.Item.VerticalLayoutTemplate>
        <RecoveryLink onClick={() => routingModule.openRecovery()}>
          {t('login.recovery.button')}
        </RecoveryLink>
      </FieldsGroup>
      <UiKit.Button
        loading={loginUIManager.coreManager.loginLoadingStatus === LoadingStatus.LOADING}
        disabled={yandexCloudManager.isBlocked}
        customStyles={{ width: '100%' }}
        type={'primary'}
        onClick={() => loginUIManager.coreManager.submitLogin()}
      >
        {t('login.submit.button')}
      </UiKit.Button>
    </LoginWrapper>
  );
};

const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const FieldsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormError = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${colorsPalette.dustyRed500};
  text-align: left;
`;

const RecoveryLink = styled.span`
  width: fit-content;
  font-family: inherit;
  font-size: 14px;
  line-height: 22px;
  color: ${colorsPalette.gray600};
  text-decoration: underline;
  cursor: pointer;
`;

LoginForm = observer(LoginForm);

export { LoginForm };
